export default __webpack_public_path__ + "static/media/FamilyNumber3.f861b95a.svg";